export default "__VITE_ASSET__DWZI3PoB__"